import _ from "lodash";
const COUNTRIES = require("../resources/countries.json");

/**
 * This is a helper function that takes an array of country-codes and
 * returns a string with a formatting as x, y & 5 others.
 * @param countryArray
 * @returns {string}
 * Example: ["x", "y", "z", "a", "b", "c", "d"] -> "x, y & 5 others"
 */
export function countriesListFormatter(countryArray) {

    let formattedCountries = [];
    let countriesList = "";
    // formatting the country list as `x, y & 5 others.`
    if (countryArray !== null) {
        countryArray.forEach(countryCode => {
            let countryLabel = _.result(_.find(COUNTRIES, {
                'value': countryCode
            }), 'label');
            formattedCountries.push(countryLabel);
        });
        if (formattedCountries.length === 1) {
            countriesList += formattedCountries.pop();
        } else if (formattedCountries.length === 2) {
            countriesList += formattedCountries.pop() + "& " + formattedCountries.pop();
        } else if (formattedCountries.length > 2) {
            let displayString = formattedCountries.pop();
            displayString += ", " + formattedCountries.pop();
            let truncatedString = " & " + formattedCountries.length + " others.";
            countriesList += displayString + truncatedString;
        }
    }

    return countriesList;
}
